<template>
  <v-row>
    <v-col>
      <v-data-table
        :custom-sort="$customSort"
        :headers="$getHeaderType1(annuityheaderTxt, annuityheaders)"
        :items="annuityList"
        hide-default-footer
        disable-pagination
        mobile-breakpoint="0"
        class="new__type__table"
      >
        <template v-slot:item.amount="{ item }">
          <template v-if="(item.amount)">
          {{ item.amount | comma }}
          </template>
          <template v-else>
            -
          </template>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
export default {
  props: {
    seq: {
      type: String
    }
  },
  data () {
		return {
      annuityheaderTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ 'annuity', 'expiration_date','grace_date','complete_payment_date','amount' ]
      },
      annuityheaders: [
        { text: this.$t('myapplication.myapplication_details.fields.annuity'), align: 'center', value: 'no', width:65},
        { text: this.$t('myapplication.myapplication_details.fields.expiration_date'), align: 'center',value: 'expiration_date', width:'25%' },
        { text: this.$t('myapplication.myapplication_details.fields.grace_date'), align: 'center',value: 'grace_date', width:'25%' },
        { text: this.$t('myapplication.myapplication_details.fields.complete_payment_date'), align: 'center',value: 'paid_date', width:'25%' },
        { text: this.$t('myapplication.myapplication_details.fields.amount'), align: 'center',value: 'amount' , width:'25%'},
      ],
      annuityList: [],
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetAnnuityList()
  },
  methods : {
    fnGetAnnuityList(){
      requestApi({
        url: '/applications/' + this.seq + '/annuities',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.annuityList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAnnuityList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
  }
}
</script>